import { useQuickSightItCompliance } from "@/hooks/useItComplianceReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsItComplianceDashboard from "@/components/organisms/ItComplianceDashboard";

function ItComplianceReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightItCompliance();

  return (
    <AWSReportsTemplate
      title="IT Compliance Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsItComplianceDashboard />
    </AWSReportsTemplate>
  );
}

export default ItComplianceReports;
